import React from "react";

export const Logo = ({ size = "md", showWordmark = true }) => {
  const sizes = {
    sm: { box: "w-14 h-9", word: "text-base" },
    md: { box: "w-16 h-10", word: "text-lg" },
    lg: { box: "w-24 h-14", word: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="flex items-center gap-1" data-testid="ng-logo">
      <img
        src="/ng-logo.png"
        alt="Newground"
        className={`${s.box} object-contain shrink-0`}
      />
      {showWordmark && (
        <span className={`font-display font-bold text-slate-900 ${s.word} tracking-tight`}>Newground</span>
      )}
    </div>
  );
};

export default Logo;
